(() => {
  'use strict';

  const config = window.DevidLocaleGuardConfig || {};
  const locale = String(config.locale || document.documentElement.lang || 'it').toLowerCase();
  const language = locale.startsWith('en') ? 'en' : 'it';
  const rootUrl = normalizeRoot(config.rootUrl || '/');

  const englishPairs = [
    ['Cerca prodotti o chiedi assistenza', 'Search products or ask for support'],
    ['Scrivi cosa cerchi o fai una domanda…', 'Type what you are looking for or ask a question…'],
    ['Scrivi un messaggio…', 'Write a message…'],
    ['Prodotti consigliati', 'Recommended products'],
    ['Risposta assistente', 'Assistant response'],
    ['Ricerche prodotto suggerite', 'Suggested product searches'],
    ['Ricerche rapide', 'Quick searches'],
    ['Hai bisogno di aiuto?', 'Need help?'],
    ['FAQ assistenza', 'Support FAQ'],
    ['Scopri', 'Discover'],
    ['Vedi proposta', 'View suggestion'],
    ['Approfondisci', 'Learn more'],
    ['Cerca comunque', 'Search anyway'],
    ['Consigli Devid Label', 'Devid Label recommendations'],
    ['Alternativa Devid Label', 'Devid Label alternative'],
    ['Da abbinare', 'Pair with'],
    ['Sto cercando la risposta migliore…', 'Finding the best answer…'],
    ['Non riesco a rispondere in questo momento. Riprova tra poco.', 'I can’t answer right now. Please try again shortly.'],
    ['Risultato coerente con la tua ricerca.', 'Result matching your search.'],
    ['Certo, inserisci il numero ordine. Lo trovi nella mail di conferma, ad esempio #91991.', 'Sure, enter your order number. You can find it in your confirmation email, for example #91991.'],
    ['Non riesco a verificare l’ordine in questo momento. Riprova tra poco o contatta l’assistenza.', 'I can’t check your order right now. Please try again shortly or contact support.'],
    ['Puoi riprovare inserendo un’altra email.', 'You can try again with another email address.'],
    ['Riprova tra poco o contatta l’assistenza.', 'Please try again shortly or contact support.'],
    ['Inserisci un indirizzo email valido per continuare.', 'Enter a valid email address to continue.'],
    ['Stato ordine', 'Order status'],
    ['Tracking spedizione', 'Shipment tracking'],
    ['Corriere:', 'Carrier:'],
    ['Segui spedizione', 'Track shipment'],
    ['Per verificare lo stato ordine usa il flusso sicuro “Dov’è il mio ordine?” in questa chat.', 'To check your order status, use the secure “Where is my order?” flow in this chat.'],
    ['Ti mostro i prodotti più vicini alla tua ricerca.', 'I’ll show you the products closest to your search.'],
    ['Mare uomo', 'Men’s beachwear'],
    ['Mare donna', 'Women’s beachwear'],
    ['Short uomo', 'Men’s shorts'],
    ['Top donna', 'Women’s tops'],
    ['Tee e polo uomo', 'Men’s tees and polos'],
    ['Camicie donna', 'Women’s shirts'],
    ['Dov’è il mio ordine?', 'Where is my order?'],
    ['Tempi di spedizione', 'Shipping times'],
    ['I tempi dipendono dal metodo di spedizione scelto e dalla destinazione. Le opzioni disponibili vengono mostrate al checkout. Non vengono effettuate spedizioni il sabato e la domenica.', 'Shipping times depend on the delivery method selected and the destination. Available options are shown at checkout. Orders are not shipped on Saturdays or Sundays.'],
    ['Pagamento alla consegna', 'Cash on delivery'],
    ['Il pagamento alla consegna è disponibile scegliendo la spedizione a domicilio al checkout. Non è disponibile con InPost, Locker o Punti InPost.', 'Cash on delivery is available when you choose home delivery at checkout. It is not available with InPost, lockers or InPost points.'],
    ['Reso facile', 'Easy returns'],
    ['Il reso è semplice. Le condizioni aggiornate sono indicate nella policy resi del sito.', 'Returns are simple. The latest conditions are listed in the returns policy on the site.'],
    ['Guida taglie', 'Size guide'],
    ['Quando disponibile, trovi la guida taglie direttamente nella scheda prodotto. Se sei indeciso tra due taglie, controlla sempre la vestibilità indicata.', 'When available, you’ll find the size guide directly on the product page. If you are between two sizes, always check the indicated fit.'],
    ['Prodotti originali', 'Original products'],
    ['Sì, i prodotti dei brand esterni sono originali. Devid Label è il nostro brand proprietario.', 'Yes, third-party brand products are original. Devid Label is our own brand.'],
    ['Categorie rapide', 'Quick categories'],
    ['Non ho trovato un ordine corrispondente a questi dati. Controlla numero ordine ed e-mail usata al checkout.', 'I couldn’t find an order matching those details. Please check the order number and the email used at checkout.'],
    ['Non riesco a completare ora la verifica sicura dell’ordine. Riprova tra poco o contatta l’assistenza.', 'I can’t complete the secure order lookup right now. Please try again shortly or contact support.'],
    ['Il tuo ordine è stato trovato. Appena la spedizione sarà affidata al corriere, il tracking sarà disponibile qui.', 'Your order was found. As soon as it is handed to the carrier, tracking will be available here.'],
    ['Scelta Devid Label', 'Devid Label pick'],
    ['Consigliato', 'Recommended'],
    ['Alternativa brand', 'Brand alternative'],
    ['Vedi prodotto', 'View product'],
    ['Disponibile', 'Available'],
    ['Non disponibile', 'Unavailable'],
    ['Carrello', 'Cart'],
    ['Il tuo carrello è vuoto', 'Your cart is empty'],
    ['Continua gli acquisti', 'Continue shopping'],
    ['Scopri le collezioni', 'Discover collections'],
    ['Vantaggi acquisto', 'Shopping benefits'],
    ['InPost sempre gratis al checkout', 'Free InPost at checkout'],
    ['Spedizione InPost sempre gratis', 'Free InPost delivery'],
    ['Reso facile entro 14 giorni', 'Easy returns within 14 days'],
    ['Pagamenti sicuri', 'Secure payments'],
    ['Vai al checkout', 'Go to checkout'],
    ['Pagamento alla consegna disponibile', 'Cash on delivery available'],
    ['Seleziona la spedizione a domicilio al checkout.', 'Select home delivery at checkout.'],
    ['Completa il look', 'Complete the look'],
    ['Suggerimenti per completare il look', 'Suggestions to complete the look'],
    ['Abbina un prodotto coerente con il tuo ordine.', 'Pair a matching item with your order.'],
    ['Suggerimenti coerenti con il brand.', 'Suggestions matching the brand.'],
    ['Abbina un prodotto Devid Label al tuo ordine.', 'Pair a Devid Label item with your order.'],
    ['Suggerimenti leggeri e pertinenti.', 'Light, relevant suggestions.'],
    ['Best seller', 'Best sellers'],
    ['Uomo', 'Men'],
    ['Donna', 'Women'],
    ['Saldi Uomo 🔥', 'Men’s Sale 🔥'],
    ['Saldi Donna 🔥', 'Women’s Sale 🔥'],
    ['DEVID LABEL | FINO AL 70% DI SCONTO', 'DEVID LABEL | UP TO 70% OFF'],
    ['LISTA BRAND', 'BRAND LIST'],
    ['Collezioni in evidenza', 'Featured collections'],
    ['Brand più cercati', 'Most searched brands'],
    ['Servizi', 'Services'],
    ['Cerca prodotti, brand, categorie', 'Search products, brands, categories'],
    ['Spedizione rapida', 'Fast shipping'],
    ['Prodotti originali 100% garantiti', '100% guaranteed original products'],
    ['SELEZIONI ESTATE · SCORRI', 'SUMMER PICKS · SCROLL'],
    ['SELEZIONI ESTATE', 'SUMMER PICKS'],
    ['MARE UOMO', 'MEN’S BEACHWEAR'],
    ['MARE DONNA', 'WOMEN’S BEACHWEAR'],
    ['SHORT UOMO', 'MEN’S SHORTS'],
    ['TOP DONNA', 'WOMEN’S TOPS'],
    ['TEE E POLO UOMO', 'MEN’S TEES & POLOS'],
    ['CAMICIE DONNA', 'WOMEN’S SHIRTS'],
    ['fino al 50%', 'up to 50%'],
    ['I SALDI che aspettavi', "The SALE you've been waiting for"],
    ['SALDI UOMO', 'MEN’S SALE'],
    ['SALDI DONNA', 'WOMEN’S SALE'],
    ['🚚 InPost gratis al checkout · 🔁 Reso facile · 💳 Pagamento alla consegna disponibile · 🔒 Checkout sicuro e protetto', '🚚 Free InPost delivery at checkout · 🔁 Easy returns · 💳 Cash on delivery available · 🔒 Secure checkout'],
    ['Scopri Ora', 'Shop now'],
    ['SCOPRI ORA', 'SHOP NOW'],
    ['I nostri cargo iconici', 'Our iconic cargo trousers'],
    ['acquista ora', 'Shop now'],
    ['Scelto da oltre 500 clienti', 'Chosen by over 500 customers'],
    ['Brand da scoprire', 'Brands to discover'],
    ['I marchi più cercati su Devid Label', 'The most searched brands at Devid Label'],
    ['Scopri ora', 'Shop now'],
    ['Scopri i best seller uomo', 'Shop men’s best sellers'],
    ['Scopri i best seller donna', 'Shop women’s best sellers'],
    ['Short UOMO', 'MEN’S SHORTS'],
    ['BORSE DONNA', 'WOMEN’S BAGS'],
    ['Tee & Polo Uomo', 'MEN’S TEES & POLOS'],
    ['NON PERDERLE', 'SHOP NOW'],
    ['Men Sale', 'Men’s Sale'],
    ['Women Sale', 'Women’s Sale']
  ];

  const translations = {
    en: new Map(englishPairs),
    it: new Map([
      ['Search & Support Assistant', 'Assistente shopping e supporto'],
      ['Prodotto aggiunto !', 'Prodotto aggiunto!'],
      ['Scopri la collection', 'Scopri la collezione']
    ])
  };

  const scopedSelectors = [
    '.header-search',
    '#cart-drawer',
    '#sidebar-menu',
    '.home-category-rail',
    '.shopify-section--slideshow',
    '.shopify-section--scrolling-content',
    '.shopify-section--image-with-text-overlay',
    '.shopify-section--featured-collections',
    '.shopify-section--homepage-brand-grid-2x2',
    '.homepage-brand-grid'
  ];

  function normalizeRoot(value) {
    let root = String(value || '/').trim();
    if (!root.startsWith('/')) root = `/${root}`;
    root = root.replace(/\/+$/, '');
    return root || '/';
  }

  function replaceTextNode(node, dictionary) {
    const original = node.nodeValue;
    const trimmed = original.trim();
    const translated = dictionary.get(trimmed);
    if (!trimmed || !translated || translated === trimmed) return;

    const leading = original.match(/^\s*/)?.[0] || '';
    const trailing = original.match(/\s*$/)?.[0] || '';
    node.nodeValue = `${leading}${translated}${trailing}`;
  }

  function translateElement(root, dictionary) {
    if (!root || root.nodeType !== Node.ELEMENT_NODE) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        return !parent || parent.closest('script, style, textarea, input, option')
          ? NodeFilter.FILTER_REJECT
          : NodeFilter.FILTER_ACCEPT;
      }
    });

    let node;
    while ((node = walker.nextNode())) replaceTextNode(node, dictionary);

    root.querySelectorAll('input[placeholder], textarea[placeholder], [aria-label], [title]').forEach((element) => {
      ['placeholder', 'aria-label', 'title'].forEach((attribute) => {
        if (!element.hasAttribute(attribute)) return;
        const translated = dictionary.get((element.getAttribute(attribute) || '').trim());
        if (translated) element.setAttribute(attribute, translated);
      });
    });
  }

  function localizeLinks(root) {
    if (rootUrl === '/' || !root) return;

    root.querySelectorAll('a[href]').forEach((anchor) => {
      const rawHref = anchor.getAttribute('href');
      if (!rawHref || /^(#|mailto:|tel:)/.test(rawHref)) return;

      let url;
      try {
        url = new URL(rawHref, window.location.origin);
      } catch (_) {
        return;
      }

      if (url.origin !== window.location.origin) return;
      if (!/^\/(collections|products|pages|search)(\/|$)/.test(url.pathname)) return;
      if (url.pathname === rootUrl || url.pathname.startsWith(`${rootUrl}/`)) return;

      url.pathname = `${rootUrl}${url.pathname}`.replace(/\/{2,}/g, '/');
      anchor.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
    });
  }

  function refineItalianText(root) {
    if (language !== 'it' || !root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if ((node.nodeValue || '').includes('Brands che iniziano con')) {
        node.nodeValue = node.nodeValue.replace('Brands che iniziano con', 'Brand che iniziano con');
      }
    }
  }

  function componentRoots(root, selector) {
    const elements = new Set();
    if (root.nodeType === Node.ELEMENT_NODE) {
      if (root.matches(selector)) elements.add(root);
      const ancestor = root.closest(selector);
      if (ancestor) elements.add(ancestor);
    }
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach((element) => elements.add(element));
    return elements;
  }

  function process(root = document) {
    const dictionary = translations[language];

    scopedSelectors.forEach((selector) => {
      componentRoots(root, selector).forEach((element) => {
        translateElement(element, dictionary);
        localizeLinks(element);
        refineItalianText(element);
      });
    });

    if (language === 'it' && (root === document || root === document.documentElement || root === document.body)) {
      translateElement(document.body, translations.it);
      refineItalianText(document.body);
    }
  }

  let scheduledRoot = null;
  let scheduled = false;

  function scheduleProcess(root) {
    scheduledRoot = root && root.nodeType === Node.ELEMENT_NODE ? root : document;
    if (scheduled) return;

    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      const rootToProcess = scheduledRoot;
      scheduledRoot = null;
      process(rootToProcess || document);
    });
  }

  process(document);

  const observer = new MutationObserver((mutations) => {
    const changedRoot = mutations.find((mutation) => mutation.target?.nodeType === Node.ELEMENT_NODE)?.target;
    scheduleProcess(changedRoot || document);
  });

  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
})();
